import Store from 'lightningjs-redux';
import {
  getVideoSource,
  getElapsedTimeInSeconds,
  getPlayerMode,
  getJingleSurfaceImageId,
  getSelectedAudioTrack,
  getSelectedSubtitlesTrack,
} from '../../logic/player/player.selectors';
import { getLifecycleState } from '../../logic/lifecycle/lifecycle.selectors';

const mapControllers = instance => [
  {
    selector: getPlayerMode,
    callback: value => {
      instance.playerMode = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getJingleSurfaceImageId,
    callback: value => {
      instance.jingleSurfaceImageId = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getLifecycleState,
    callback: value => {
      instance.lifecycleState = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getVideoSource,
    callback: value => {
      instance.source = value;
    },
    shouldBeInvokedOnConnect: true,
  },
  {
    selector: getElapsedTimeInSeconds,
    callback: value => {
      instance.elapsedTimeInSeconds = value;
    },
  },
  {
    selector: getSelectedAudioTrack,
    shouldBeInvokedOnConnect: false,
    callback: value => {
      instance.setAudioTrackById(value);
    },
  },
  {
    selector: getSelectedSubtitlesTrack,
    shouldBeInvokedOnConnect: false,
    callback: value => {
      instance.setSubtitlesTrackById(value);
    },
  },
];

export default Store.control(mapControllers);
